import ReactApexChart from 'react-apexcharts';
import { Box, Card, CardHeader } from '@mui/material';

import { useChart } from '../../../components/chart';

/** Carries a `fill` alongside the series so the chart can build its fill types. */
export type AppWebsiteVisitsSeries = {
    name: string;
    type?: string;
    fill: string;
    data: number[];
};

export type AppWebsiteVisitsProps = {
    title?: string;
    subheader?: string;
    chartLabels: string[];
    chartData: AppWebsiteVisitsSeries[];
};

export default function AppWebsiteVisits(
    { title, subheader, chartLabels, chartData, ...other }: AppWebsiteVisitsProps) {

    const chartOptions = useChart({
        plotOptions: { bar: { columnWidth: '16%' } },
        fill: { type: chartData.map((i) => i.fill) },
        labels: chartLabels,
        xaxis: { type: 'datetime' },
        yaxis: { min: 0, show: false },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (y: number) => {
                    if (typeof y === 'undefined') return y;
                    return y.toFixed(0);
                },
            },
        },
    });

    return (
        <Card { ...other }>
            <CardHeader title={ title } subheader={ subheader }/>

            <Box sx={ { p: 3, pb: 1 } } dir="ltr">
                <ReactApexChart type="line" series={ chartData } options={ chartOptions } height={ 364 }/>
            </Box>
        </Card>
    );
}
